import React from 'react';
import { cn } from '@express-labs/raven-tools';

import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const ArrowBack: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--arrowBack')}
    data-icon={icon}
    width="11"
    height="18"
    viewBox="0 0 11 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Back-Arrow" fill="#000000">
        <polygon
          id="Arrow-Back"
          points="0 8.85 8.87481689 0 10.081605 1.240625 2.47784424 8.85 10.081605 16.5053955 8.87481689 17.7227182"
        />
      </g>
    </g>
  </svg>
);

export default ArrowBack;
